import React from 'react';
import { StateContext } from '../services/LabSimService';
import { T } from '@testout/labsim-ui-atomics';
import styles from './GradingControl.module.less';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => React.createElement(GradingControl, Object.assign({}, props, { context: stateContext })))));
export var GradingControlEventType;
(function (GradingControlEventType) {
    GradingControlEventType[GradingControlEventType["CHECKBOX_CHANGE"] = 0] = "CHECKBOX_CHANGE";
    GradingControlEventType[GradingControlEventType["VALUE_CHANGE"] = 1] = "VALUE_CHANGE";
    GradingControlEventType[GradingControlEventType["ASSIGNMENT_CHANGE"] = 2] = "ASSIGNMENT_CHANGE";
})(GradingControlEventType || (GradingControlEventType = {}));
class GradingControl extends React.Component {
    constructor(props) {
        super(props);
        this.handleCanvasLoad = () => {
            if (this.props.onReady && this.props.context.canvasAssignmentGroups.length > 0) {
                this.setState({ selectedAssignmentGroup: this.props.context.canvasAssignmentGroups[0].id }, () => {
                    if (this.props.onReady) {
                        this.props.onReady({
                            assignment: this.state.selectedAssignmentGroup,
                            disabled: this.state.disabled,
                            type: GradingControlEventType.ASSIGNMENT_CHANGE,
                            value: this.state.pointValue,
                        });
                    }
                });
            }
        };
        this.handleCheckboxChange = (value) => {
            this.setState((state) => ({ disabled: !state.disabled }), () => {
                this.props.onChange({
                    assignment: this.state.disabled ? '' : this.state.selectedAssignmentGroup,
                    disabled: this.state.disabled,
                    type: GradingControlEventType.CHECKBOX_CHANGE,
                    value: this.state.pointValue,
                });
            });
        };
        this.handleNumberInputChange = (points) => {
            var _a, _b;
            const parsed = parseInt(points);
            if (isNaN(parsed) ||
                parsed < ((_a = this.props.min) !== null && _a !== void 0 ? _a : 1) ||
                parsed > ((_b = this.props.max) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER))
                return;
            // tslint:disable-next-line:radix
            this.setState({ pointValue: parsed }, () => {
                this.props.onChange({
                    assignment: this.state.selectedAssignmentGroup,
                    disabled: this.state.disabled,
                    type: GradingControlEventType.VALUE_CHANGE,
                    value: this.state.pointValue,
                });
            });
        };
        this.handleAssignmentChange = (e) => {
            this.setState({ selectedAssignmentGroup: e }, () => {
                this.props.onChange({
                    assignment: this.state.selectedAssignmentGroup,
                    disabled: this.state.disabled,
                    type: GradingControlEventType.ASSIGNMENT_CHANGE,
                    value: this.state.pointValue,
                });
            });
        };
        this.state = {
            disabled: props.disabled,
            pointValue: 100,
            selectedAssignmentGroup: '',
        };
        props.context.onCanvasDataLoaded().then(this.handleCanvasLoad);
    }
    handleFocus(e) {
        e.currentTarget.select();
    }
    render() {
        return (React.createElement(StateContext.Consumer, null, (stateContext) => {
            return (React.createElement("div", { className: styles.fieldset },
                React.createElement(T.Form.Fieldset, { automationId: 'gradeControl' },
                    React.createElement(T.Fieldset.Legend, null,
                        React.createElement(T.Input.Checkbox, { name: 'shouldGrade', onChange: this.handleCheckboxChange, checked: !this.state.disabled }, "Graded")),
                    this.state.disabled && (React.createElement(T.Text.P, { automationId: 'ungraded', variation: T.Text.Variation.Small }, this.props.offText)),
                    !this.state.disabled && (React.createElement("div", { className: styles.container },
                        stateContext.isFamilyCanvas() && (React.createElement(T.Form.Field, { automationId: 'assignmentSelect', required: true }, stateContext.canvasDataLoaded ? (React.createElement(React.Fragment, null,
                            React.createElement(T.Form.Label, null, "Assignment Group"),
                            React.createElement(T.Form.Select, { onChange: this.handleAssignmentChange, value: this.state.selectedAssignmentGroup }, stateContext.canvasAssignmentGroups.map((g) => (React.createElement(T.Select.Option, { key: g.id, value: g.id }, g.name)))))) : (React.createElement(T.Loading.Inline, null)))),
                        React.createElement(T.Form.Field, { automationId: 'points', required: true },
                            React.createElement(T.Form.Label, null, "Point Value"),
                            React.createElement(T.Form.InputText, { onFocus: this.handleFocus, onChange: this.handleNumberInputChange, value: this.state.pointValue.toString() })))))));
        }));
    }
}
//# sourceMappingURL=GradingControl.js.map